export const formRows = [
  {
    span: 24,
    label: "上级组织",
    component: "ATreeSelect",
    placeholder: "请选择",
    prop: "parentId",
    list: [],
    allowClear: true,
    disabled: false,
  },
  {
    span: 24,
    label: "组织名称",
    component: "AInput",
    placeholder: "请输入",
    prop: "deptName",
    allowClear: true,
  },
  {
    span: 24,
    label: "显示排序",
    component: "AInput",
    placeholder: "请输入",
    prop: "orderNum",
    allowClear: true,
  },
  // {
  //   span: 24,
  //   label: "用户数",
  //   component: "AInput",
  //   placeholder: "请输入",
  //   prop: "num",
  //   allowClear: true,
  //   disabled: false,
  // },
  {
    span: 24,
    label: "负责人",
    component: "AInput",
    placeholder: "请输入",
    prop: "leader",
    allowClear: true,
  },
  {
    span: 24,
    label: "联系电话",
    component: "AInput",
    prop: "phone",
    placeholder: "请输入",
    allowClear: true,
  },
  {
    span: 24,
    label: "邮箱",
    component: "AInput",
    placeholder: "请输入",
    prop: "email",
    allowClear: true,
  },
];
const reg1 = new RegExp(
  "^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$"
); // 校验手机号
export const formRules = {
  phone: [
    //{ required: false, message: "请输入手机号码", trigger: "change" },
    {
      validator: (rule, val, callback) => {
        if (val && !reg1.test(val)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      },
    },
  ],
  email: [{ required: false }, { type: "email", message: "请输入正确的邮箱!" }],
  orderNum: [{ required: true, message: "请输入排序", trigger: "change" }],
  deptName: [{ required: true, message: "请输入组织名称", trigger: "change" }],
  parentId: [{ required: true, message: "请选择上级组织", trigger: "change" }],
};
